<template>
  <v-main>
    <AcceptInvitePopup v-if="id" :invite-id="id" @accept-data="onAcceptData($event)"/>
    <Card class="card pt-md-10 mb-md-6 mb-6" title="Регистрация партнера">
      <InitForm v-if="stage === 'start'"/>
      <ConfirmationForm v-else-if="stage === 'confirmation'" />
      <PasswordForm v-else-if="stage === 'password'"/>
    </Card>
    <div class="font--action-small font--color_light text-center">
      <span class="mr-1">Уже Зарегистрированы?</span>
      <router-link class="text-link text-decoration-none" to="/account/login">Войти</router-link>
    </div>
  </v-main>
</template>

<script>
import Card from "@/components/login/Card";
import InitForm from "@/components/login/InitForm";
import ConfirmationForm from "@/components/login/ConfirmationForm";
import PasswordForm from "@/components/login/PasswordForm";
import AcceptInvitePopup from "@/components/login/AcceptInvitePopup";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  props: ['id'],
  components: {
    Card,
    InitForm,
    ConfirmationForm,
    PasswordForm,
    AcceptInvitePopup,
  },
  data() {
    return {
      phone: null,
      inviteId: null
    }
  },
  computed: mapGetters("registration", ["stage", "clid"]),
  methods: {
    ...mapActions("common", ["clearErrdesc"]),
    // ...mapActions(["reset"]), // старое?
    ...mapMutations("registration", ["reset", "setClid"]),
    onAcceptData({ phone, inviteId }) {
      this.phone = phone;
      this.inviteId = inviteId;
    }
  },

  // сбрасываем состояние для регистрации с сохранением clid
  // например при срабатывании редиректа на логин, и возвращении
  // к регистрации с другим номером, т.е. без query параметров
  mounted() {
    const clid = this.$route.query.clid || this.clid;
    this.reset();

    if (clid) {
      this.setClid(clid);
    }
  },
  destroyed() {
    this.clearErrdesc();
  },
};
</script>
<style scoped>
@media (max-width: 600px) {
  .card {
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>
